import { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import countries from 'i18n-iso-countries'

import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from 'redux/store'
import { BrowserRouter as Router } from 'react-router-dom'

if (process.env.REACT_APP_ENVIRONMENT === 'production') { console.log = () => {} }

countries.registerLocale(require('i18n-iso-countries/langs/en.json'))

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
